<template>
    <v-container fluid px-3 pt-3>
        <v-row>
            <v-col cols="12">
                <h3>Login Error</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h3 v-if="error">{{error}}</h3>
            </v-col>
            <v-col cols="12">
                <div v-if="errorDescription">{{errorDescription}}</div>
                <div v-if="errorDescription.includes('verify your email')">
                    A new email verification link has been sent to your email address associated with your account.
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'LoginError',
    components: {
        //HelloWorld
    },
    data () {
        return {
            error: this.$route.query.error,
            errorDescription: this.$route.query.error_description,
            logout: this.$route.query.logout
        }
    },
    mounted () {
        this.checkLogout()
    },
    watch: {
        $auth: function () {
            this.checkLogout()
        }
    },
    methods: {
        checkLogout () {
            if (this.error && !this.logout && this.$auth) {
                this.$auth.logout({
                    returnTo: window.location.href + '&logout=true'
                })
            }
        }
    }
}

</script>
